module.exports = __webpack_public_path__ + "img/reference-kub.98748ee0.jpg";